import { Carousel } from 'antd';
import "./home.css"
import { Image } from "antd"
function Home(){
    const onChange = (currentSlide) => {
        // console.log(currentSlide);
    };
    const swiperImages = [
        {
            al:"showroom1",
            srcName:require('../../../assets/images/swipers/showroom.jpg')
        },
        {
            alt:"factory1",
            srcName:require('../../../assets/images/swipers/factory-1.jpg')
        },
        {
            alt:"factory2",
            srcName:require('../../../assets/images/swipers/factory-2.jpg')
        },
        {
            alt:"factory3",
            srcName:require('../../../assets/images/swipers/factory-3.jpg')
        },
        {
            alt:"factory4",
            srcName:require('../../../assets/images/swipers/factory-4.jpg')
        },
        {
            alt:"showroom2",
            srcName:require('../../../assets/images/swipers/showroom-2.jpg')
        },
    ]
    return <div className="homeSwiper" id="home-1">
        <Carousel afterChange={onChange} arrows={ true } autoplay={ true } autoplaySpeed={ 2000 }>
            {
                swiperImages.map((item, index) => {
                    return  <div key={ item.alt + index } className='swiper-item'>
                                <Image key={ item.alt + index } preview={ false } alt={ item.alt } src={ item.srcName }/>
                            </div>
                })
            }
        </Carousel>
    </div>
}
export default Home;